import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Layout } from "@/components/Layout";

export default function PaymentCancel() {
  return (
    <Layout page="payment-cancel">
      <section className="relative min-h-[80vh] flex items-center justify-center px-5">
        <div className="relative w-full max-w-lg rounded-3xl bg-ink-800/95 border border-white/12 shadow-2xl backdrop-blur-xl p-10 text-center" data-testid="payment-cancel">
          <div className="mx-auto h-16 w-16 rounded-full bg-white/10 flex items-center justify-center mb-5"><XCircle className="text-ice/70" size={30} /></div>
          <h1 className="font-display text-3xl font-bold text-white">Payment cancelled.</h1>
          <p className="text-ice/70 mt-3">No charge was made. You can pick up right where you left off whenever you're ready.</p>
          <Link to="/book" data-testid="cancel-back" className="book-cta mt-8 mx-auto">Back to booking</Link>
        </div>
      </section>
    </Layout>
  );
}
